import {
	ProductPlatforms,
	type ProductCategoryReturnReponse,
	type ProductPlatformKeys,
	type ProductReturnResponse
} from '~/server/type'
import type { IRequestResponse, ProductContext } from '~/types'

export const useProductApi = () => {
	const getProducts = async (user_type: ProductPlatformKeys = ProductPlatforms.BUSINESS, query?: Object) => {
		const result = await $fetch<IRequestResponse<ProductReturnResponse>>('/api/bff/v1/product-list', {
			query: { user_type, ...(query || {}) },
			cache: 'no-cache'
		})
		const response = result?.data || null

		return response
	}

	const getProductCategories = async (
		filter?: { codes: number[]; product_category: string } | null,
		user_type: ProductPlatformKeys = ProductPlatforms.BUSINESS
	) => {
		const { codes, product_category } = filter || {}
		const result = await $fetch<IRequestResponse<ProductCategoryReturnReponse>>(
			'/api/bff/v1/grouped-products-by-category',
			{
				query: {
					filter: {
						codes,
						product_category
					},
					user_type
				}
			}
		)
		return result?.data || null
	}
	const getProductFromId = async (product_id: string, user_type: ProductPlatforms = ProductPlatforms.BUSINESS) => {
		const result = await useAPI<IRequestResponse<ProductContext[number]>>(`/products/${product_id}`, {
			cache: 'no-cache',
			query: { user_type }
		})
		return result.data
	}

	return {
		getProducts,
		getProductCategories,
		getProductFromId
	}
}
